import request from "@/utils/request";

// 获取列表 
export function GetSuccessfulTrade(params) {
  return request({
    url: "/h5/TradeDetails/index",
    method: "post",
    params,
  });
}
